<template lang="pug">
.SingleWork(class="window")
  //- p.year {{ currentYear }}
  WorkHeading {{ work.client }}
  div.info
    .intro {{ work.about }}
    .projects
      .project(v-for="project in work.projects")
        h3.project__title(v-if="work.projects.length > 1")
          | {{ project.title }}
          sup.project__year {{ project.year }}
        p.project__intro(v-if="work.projects.length > 1") {{ project.intro }}
        vimeo-player.project__video(v-show="project.video" :video-id="project.video" :options="videoOptions")
        section.project__content
          div.content-block(v-for="block in project.content" :class="'content-block--' + block.type")
            p(v-show="block.type === 'text'") {{ block.text }}
            SideScroller(v-show="block.type === 'gallery' && block.images.length > 0" :images="block.images.map(getImage)")
      .content-block.content-block--credits.closed(v-if="work.credits.length > 0")
        // h4(@click="showCredits = !showCredits") {{ showCredits ? '- ' : '+ ' }} Creditos
        h4 Creditos:
        ul(v-show="showCredits"): li(v-for="person in work.credits") <b>{{ person.job }}:</b> {{ person.name }}
</template>

<script>
import WorkHeading from '@/components/WorkHeading'
import SideScroller from '@/components/SideScroller'
import { TweenMax, TimelineLite, Power4 } from 'gsap'

export default {
  name: 'home',
  components: { WorkHeading, SideScroller },
  data() {
    return {
      videoOptions: {
        byline: false,
        portrait: false,
        title: false
      },
      work: this.$store.state.works.find(
        work => work.slug === this.$route.params.slug
      ),
      showCredits: true
      // yearEl: undefined,
      // currentYear: undefined,
      // projectsTop: 0,
      // yearScroll: 0,
      // scrollTriggers: []
    }
  },
  methods: {
    getImage(image) {
      return require(`@/assets/images/${image}`)
    }
    // animateYear () {
    //   let newVal = 32 // window.innerHeight * .4
    //   if (window.scrollY < window.innerHeight) newVal = this.projectsTop - window.scrollY * 0.6
    //   this.yearScroll = lerp(this.yearScroll, newVal, 0.1)
    //   this.yearEl.style.top = this.yearScroll + 'px'
    //   this.currentYear = this.scrollTriggers.filter(trig => window.scrollY * 0.6 - window.innerHeight / 2 < trig.scrollValue)[0].year

    //   if (this.yearEl.textContent !== this.currentYear) {
    //     this.yearEl.textContent = this.currentYear
    //   }

    //   requestAnimationFrame(this.animateYear)
    // }
  },
  mounted() {
    this.$emit('navigationName', 'singleWork')
    // this.yearEl = this.$el.querySelector('p.year')
    // this.projectsTop = this.$el.querySelector('.projects').getBoundingClientRect().top
    document.title = `M© — ${this.work.client}`
    TweenMax.from(
      '.info',
      1,
      {
        autoAlpha: 0,
        y: 300,
        ease: Power4.easeOut
      },
      0.15
    )

    // document.querySelectorAll('.project').forEach(projectEl => {
    //   const projectYear = projectEl.querySelector('.project__year').textContent
    //   const projectTop = projectEl.getBoundingClientRect().top
    //   this.scrollTriggers.push({ scrollValue: projectTop, year: projectYear })
    // })

    // this.animateYear()
  },
  beforeRouteLeave(to, from, next) {
    const outTL = new TimelineLite({ onComplete: next })
    outTL.staggerTo(
      this.$el.children,
      1,
      { autoAlpha: 0, x: -20, ease: Power4.easeInOut },
      0.3
    )
  }
}
</script>

<style lang="scss">
.window {
  color: black;
  @include grid(1, 7);
  padding: 4rem 0;

  @include desktop {
    padding: 5rem 0;
    @include grid(2, 6);
  }

  .intro {
    margin-top: $fs-xl;
    margin-bottom: $fs-xxl;
    @include grid-child(0, 7);

    @include desktop {
      @include grid-child(0, 5);
    }
  }
}

.year {
  display: none;

  @include desktop {
    margin: 0;
    @include grid(7, 1);
    position: fixed;
    text-align: right;
    display: block;
    font-weight: bold;
    font-size: $fs-l;
    line-height: $fs-xxl;
    vertical-align: super;
  }
}

.project {
  color: black;
  margin: 3rem 0;
  @include grid-child(0, 7);
  position: relative;

  @include desktop {
    @include grid-child(0, 5);
  }

  &__title {
    font-size: $fs-l;
    line-height: 1.2em;
    margin: 0;
    margin-bottom: 1em * ($phi - 1);
    vertical-align: super;

    @include desktop {
      font-size: $fs-xl;
    }
  }

  &__year {
    display: none;
    margin: 0;
    font-weight: bold;
    font-size: $fs-s;
    margin-bottom: 1em * ($phi - 1);
    vertical-align: $fs-xl;

    @include desktop {
      /* display: none; */
    }
  }

  &__intro {
    font-size: $fs-l;
    font-weight: normal;
    margin: 0;
    font-weight: normal;
    @include grid-child(0, 6);

    @include desktop {
      @include grid-child(0, 4);
    }
  }

  &__video {
    margin: 3rem 0;

    &,
    > iframe {
      width: 100%;
      height: calc(#{getWidth(7, $margins-m)} / (16 / 9));

      @include desktop {
        height: calc(#{getWidth(5, $margins-d)} / (16 / 9));
      }
    }
  }
}

.content-block {
  margin: 2.5rem 0;

  @include desktop {
    margin: 5em 0;
  }

  &,
  p {
    font-weight: normal;
  }

  &--credits {
    @include grid-child(0, 7);
    display: flex;

    h4 {
      @include grid-child(0, 1);
      height: 1.8em;
      // cursor: pointer;
      margin: 0;
      line-height: 0.8em;
    }

    ul {
      font-size: $fs-s;
      list-style: none;
      padding: 0;
      margin: 0;
      @include grid-child(0, 6);
      margin-left: 4rem;

      @include desktop {
        @include grid-child(0, 4);
      }

      li {
        font-weight: normal;
        margin-right: 0.3em;

        @include desktop {
          display: inline-block;
        }
      }
    }

    @include desktop {
      @include grid-child(0, 5);
    }
  }
}

video {
  opacity: 0;
  object-fit: cover;
  transition: 0.5s $ease-out;
}
</style>
